<template>
<div class="down-card">
  <el-row :gutter="24">
    <el-col
      :lg="12"
      :sm="24"
      :xs="24"
    >
      <div class="card-left">
        <div class="title">{{mt4CardInfo.title}}</div>
        <div class="subtitle">{{mt4CardInfo.subtitle}}</div>
        <img
          class="big-img"
          :src="mt4CardInfo.imgBg" alt="">
      </div>
    </el-col>
    <el-col
      :lg="12"
      :sm="24"
      :xs="24"
    >
      <div class="list-link">
        <a
          v-for="(item,index) in mt4CardInfo.clienlists"
          :key="index"
          download target="_blank"
          :href="item.link"
          class="small-card">
          <div class="img-box">
            <svg
              class="svg-icon" style="font-size: 24px" aria-hidden="true" >
              <use :xlink:href="`#${item.symbol}`"></use>
            </svg>
          </div>
          <div class="right-box">
            <div class="three-title">{{item.smallText}}</div>
            <div class="desc">{{item.desc}}</div>
          </div>
        </a>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  name: "mt4Card",
  props: {
    mt4CardInfo: {
      type: Object,
      default(){
        return {
          imgBg: '../../assets/images/customer/mt4Bg.png',
          title: 'MT4',
          subtitle: '下载 MetaTrader 4，体验最佳交易！',
          clienlists: [
            {
              symbol: 'iconWindows',
              smallText: 'Windows 桌面版',
              desc: '系统要求：适用于Windows 2008/7/8/10操作系统',
              link: 'https://download.mql5.com/cdn/web/14889/mt4/redstonemarketsltd4setup.exe',
            },
            {
              symbol: 'iconiOS',
              smallText: 'iOS 移动端',
              desc: '下载说明：iPhone和iPad用户可以通过Apple App Store搜索MetaTrader4安装。',
              link: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/MetaTrader4.dmg'
            },
            {
              symbol: 'iconAndroid',
              smallText: 'Android APK',
              desc: '下载说明：下载后可以通过手机安装APK',
              link: 'https://oss-hk2069.oss-cn-hongkong.aliyuncs.com/files/metatrader4.apk'
            },
          ]
        }
      }
    },
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.down-card {
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 24px;
  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #5E5873;
  }
  .subtitle {
    color: #6E6B7B;
    font-size: 14px;
    margin-bottom: 24px;
  }
  .big-img {
    width: 100%;
  }
  .list-link {
    .small-card {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border: 1px solid #EBE9F1;
      border-radius: 6px;
      padding: 20px;
      margin-bottom: 8px;
      .img-box {
        margin-right: 12px;
      }
      .icon-img {
        width: 30px;
      }
      .three-title {
        color: #6E6B7B;
        font-size: 14px;
      }
      .desc {
        color: #B9B9C3;
      }
    }
  }
}
</style>
